<p-confirmDialog key="modifysub" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div style="height: 430px; min-width: 460px">
	<!--Main Grid-->
	<div id="MainGrid" class="MainGrid2Col">
		<label>Sub:</label>
		<label class="InfoText">{{ PersonName }}</label>

		<!-- <label>Subbing for Instructor:</label>
        <select class="form-control" name="Instructor_PersonID" [(ngModel)]="Instructor_PersonID">
            <option value="" style="display:none;"></option>
            <option *ngFor="let o of lstInstructor" [ngValue]="o.Instructor_PersonID">{{o.FirstName}} {{o.LastName}}</option>
        </select> -->

		<label>Subbing For:</label>
		<!--Drop Down-->
		<p-dropdown
			[options]="lstInstructor"
			[(ngModel)]="SelectedInstructor"
			optionLabel="PersonName"
			[filter]="true"
			filterBy="PersonName"
			[showClear]="false"
			placeholder="Select an Instructor to Substitute for"
			(ngModelChange)="onInstructorChange($event)"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="SelectedInstructor">
					<div class="form-control NoBorder" style="text-align: left">
						{{ SelectedInstructor.PersonName }}
					</div>
				</div>
			</ng-template>
			<ng-template let-PersonItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ PersonItem.PersonName }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>Start Date:</label>
		<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="StartDate" name="StartDate" (onShow)="onShow()" (onClose)="onHide()"></p-calendar>

		<label>End Date:</label>
		<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="EndDate" name="EndDate" (onShow)="onShow()" (onClose)="onHide()"></p-calendar>
	</div>

	<!--Buttons-->
	<div id="ButtonDiv" class="Buttons">
		<button *ngIf="EditMode == false" class="btn btn-primary" (click)="onAdd()">Add</button>
		<button *ngIf="EditMode == true" class="btn btn-primary" (click)="onEdit()">Update</button>
		<button class="btn btn-primary" (click)="onClose()">Close</button>
	</div>

	<!--Error Message-->
	<div class="TopMargin">
		<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
			{{ errorMessage }}
		</div>
	</div>
</div>
